import { BaseIcon, BaseIconProps } from "./baseIcon";

export const EarnActiveIcon = (props: BaseIconProps) => {
  return (
    <BaseIcon {...props}>
      <g id="Earn">
        <path
          d="M10.7999 2C15.2182 2 18.7999 5.58172 18.7999 10C18.7999 14.4183 15.2182 18 10.7999 18C6.38165 18 2.79993 14.4183 2.79993 10C2.79993 5.58172 6.38165 2 10.7999 2ZM9.79993 7C8.69536 7 7.79993 7.89543 7.79993 9V11C7.79993 12.1046 8.69536 13 9.79993 13H11.7999C12.9045 13 13.7999 12.1046 13.7999 11V9C13.7999 7.89543 12.9045 7 11.7999 7H9.79993Z"
          fill="url(#paint0_linear_earn_active)"
        />
        <path
          d="M19.6034 8.1276C19.5434 7.84577 19.8603 7.62722 20.0756 7.81876C21.7466 9.3053 22.8005 11.4702 22.8005 13.8826C22.8002 18.3657 19.1655 22.0005 14.6824 22.0007C12.27 22.0007 10.1051 20.9467 8.61857 19.2758C8.42703 19.0605 8.64561 18.7434 8.92748 18.8033C9.53166 18.9317 10.1582 18.9998 10.8005 18.9998C10.9368 18.9997 11.0722 18.9957 11.207 18.9893C11.2715 18.9862 11.3354 19.0036 11.3898 19.0385C12.3404 19.6468 13.4701 20.0007 14.6824 20.0007C17.9555 20.0005 20.6288 17.4294 20.7927 14.197L20.8005 13.8826C20.8005 12.6708 20.4471 11.5414 19.8392 10.591C19.8044 10.5365 19.787 10.4727 19.79 10.4082C19.7965 10.2728 19.8005 10.1365 19.8005 9.99976C19.8005 9.35761 19.7321 8.73148 19.6034 8.1276Z"
          className="oui-fill-base-contrast-54"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_earn_active"
          x1="18.7999"
          y1="10"
          x2="2.79993"
          y2="10"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="rgb(var(--oui-gradient-brand-end))" />
          <stop offset="1" stopColor="rgb(var(--oui-gradient-brand-start))" />
        </linearGradient>
      </defs>
    </BaseIcon>
  );
};
